const Title = ({ title }) => {
    return <h1 className="baseocom-title_niv_1">{title}</h1>
}
export default Title
